import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const skinModule = {
    state: {
        show: true
    },
    getters: getters,
    mutations: mutations,
    actions: actions
};

export default skinModule;


// WEBPACK FOOTER //
// ./src/_store/modules/tabBar/index.js